import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WixSDK from 'shared/utils/wix-sdk';
import { updatePremiumIntent } from 'shared/utils/premium-intent';
import viewModes from 'shared/constants/view-modes';

import getVodSettings from 'shared/redux/server/actions/vod-settings/get';
import getExperiments from 'shared/redux/server/actions/experiments/get';
import { isPremiumIntentEnabled } from 'shared/selectors/experiments';

@connect(store => ({
  isPremiumIntentEnabled: isPremiumIntentEnabled(store),
  vodSettings: store.vodSettings,
  experiments: store.experiments,
}), {
  getVodSettings,
  getExperiments,
})
export default class PremiumIntentUpdater extends React.Component {

  static propTypes = {
    isPremiumIntentEnabled: PropTypes.bool,
    vodSettings: PropTypes.object,
    experiments: PropTypes.object,
    getVodSettings: PropTypes.func,
    getExperiments: PropTypes.func,
  };

  componentDidMount() {
    const { getVodSettings, getExperiments } = this.props;
    if (WixSDK.Utils.getViewMode() === viewModes.EDITOR) {
      getVodSettings();
      getExperiments();
    }
  }

  componentWillUpdate(nextProps) {
    const { isPremiumIntentEnabled, vodSettings, experiments } = nextProps;
    const { isPremiumIntentUpdated } = this;

    if (!isPremiumIntentEnabled || isPremiumIntentUpdated || _.isEmpty(experiments) || _.isEmpty(vodSettings)) {
      return;
    }

    const { biUserUploadedFiles } = vodSettings;

    updatePremiumIntent({
      hasUploadedVideos: biUserUploadedFiles,
    });

    this.isPremiumIntentUpdated = true;
  }

  isPremiumIntentUpdated = false;

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/premium-intent-updater/premium-intent-updater.js